import React from 'react';
import { ChakraProvider, Box, Flex } from '@chakra-ui/react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { TimezoneProvider } from './contexts/TimezoneContext';
import { LoginPage } from './pages/LoginPage';
import { EventsPage } from './pages/EventsPage';
import { EventDetailsPage } from './pages/EventDetailsPage';
import { TradingDashboardPage } from './pages/TradingDashboardPage';
import { TradingEventDetailsPage } from './pages/TradingEventDetailsPage';
import { DexchTradingPage } from './pages/DexchTradingPage';
import { DexchEventDetailsPage } from './pages/DexchEventDetailsPage';
import { WebSocketTest } from './pages/WebSocketTest';
import { FLSDashboardPage } from './pages/FLSDashboardPage';
import { TemplatePricesPage } from './pages/TemplatePricesPage';
import { ModelingPage } from './pages/ModelingPage';
import { MarketControlsPage } from './pages/MarketControlsPage';
import { AppHeader } from './components/AppHeader';
import { Footer } from './components/Footer';

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const { isAuthenticated } = useAuth();
    return isAuthenticated ? <>{children}</> : <Navigate to="/" />;
};

function App() {
    return (
        <ChakraProvider>
            <Router>
                <AuthProvider>
                    <TimezoneProvider>
                        <Flex direction="column" minH="100vh">
                        <AppHeader />
                        <Box p={{ base: 2, md: 4 }} flex="1">
                            <Routes>
                                <Route path="/" element={<LoginPage />} />
                                <Route
                                    path="/events"
                                    element={
                                        <ProtectedRoute>
                                            <EventsPage />
                                        </ProtectedRoute>
                                    }
                                />
                                <Route
                                    path="/events/:id"
                                    element={
                                        <ProtectedRoute>
                                            <EventDetailsPage />
                                        </ProtectedRoute>
                                    }
                                />
                                <Route
                                    path="/fls-dashboard"
                                    element={
                                        <ProtectedRoute>
                                            <FLSDashboardPage />
                                        </ProtectedRoute>
                                    }
                                />
                                <Route
                                    path="/template-prices"
                                    element={
                                        <ProtectedRoute>
                                            <TemplatePricesPage />
                                        </ProtectedRoute>
                                    }
                                />
                                <Route
                                    path="/ws-test"
                                    element={
                                        <ProtectedRoute>
                                            <WebSocketTest />
                                        </ProtectedRoute>
                                    }
                                />
                                <Route
                                    path="/trading"
                                    element={<TradingDashboardPage />}
                                />
                                <Route
                                    path="/trading/:id"
                                    element={<TradingEventDetailsPage />}
                                />
                                <Route
                                    path="/dexch-trading"
                                    element={<DexchTradingPage />}
                                />
                                <Route
                                    path="/dexch-trading/:id"
                                    element={<DexchEventDetailsPage />}
                                />
                                <Route
                                    path="/modeling"
                                    element={<ModelingPage />}
                                />
                                <Route
                                    path="/market-controls"
                                    element={<MarketControlsPage />}
                                />
                            </Routes>
                        </Box>
                        <Footer />
                        </Flex>
                    </TimezoneProvider>
                </AuthProvider>
            </Router>
        </ChakraProvider>
    );
}

export default App;
